// Source/Content-Slider/Component.ts
import { Swiper } from "Swiper";
class Content_Slider extends HTMLElement {
  swiper;
  connectedCallback() {
    this.#markSlides();
    const { $pagination, $next, $prev } = this;
    const options = {
      updateOnWindowResize: true,
      slidesPerView: this.mobileSlides,
      spaceBetween: this.gap,
      loop: this.loop,
      breakpoints: {
        800: {
          slidesPerView: this.tabletSlides
        },
        1600: {
          slidesPerView: this.desktopSlides
        },
        2000: {
          slidesPerView: this.ultrawideSlides
        }
      }
    };
    if ($next && $prev)
      options.navigation = {
        nextEl: $next,
        prevEl: $prev
      };
    if ($pagination)
      options.pagination = {
        clickable: true,
        el: $pagination
      };
    this.swiper = new Swiper(this.$swiper, options);
  }
  disconnectedCallback() {
    this.swiper.destroy();
  }
  #markSlides() {
    for (const child of Array.from(this.$wrapper.children)) {
      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");
      child.replaceWith(slide);
      slide.append(child);
    }
  }
  get mobileSlides() {
    return Number(this.dataset.mobileSlides ?? 1);
  }
  get tabletSlides() {
    return Number(this.dataset.tabletSlides ?? 2);
  }
  get desktopSlides() {
    return Number(this.dataset.desktopSlides ?? 3);
  }
  get ultrawideSlides() {
    return Number(this.dataset.ultrawideSlides ?? 3);
  }
  get gap() {
    const probe = document.createElement("div");
    probe.style.position = "absolute";
    probe.style.visibility = "hidden";
    probe.style.width = "var( ---Gap , 0px )";
    this.append(probe);
    const gap = probe.getBoundingClientRect().width;
    probe.remove();
    return gap;
  }
  get loop() {
    return this.dataset.loop === "true";
  }
  get $swiper() {
    return this.querySelector(`.swiper`);
  }
  get $wrapper() {
    return this.querySelector(`.swiper-wrapper`);
  }
  get $pagination() {
    return this.querySelector(`.swiper-pagination`);
  }
  get $next() {
    return this.querySelector(`.swiper-button-next`);
  }
  get $prev() {
    return this.querySelector(`.swiper-button-prev`);
  }
}

// Source/Content-Slider/mod.ts
customElements.define("content-slider", Content_Slider);
